module.exports = __webpack_public_path__ + "static/media/2_5.64d3a6e2.png";